import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Button, Header, Paper, Title, Toggle } from '../../components';
import Form from './loyaltyProgram.form';

import { config } from '../../api/config';
import { actions } from '../../state';
import { LoyaltyProgramStatus } from '../../utils/global/enums';
import { uuidValidateV4 } from '../../utils';
import { mapGoalToApiPayload } from './loyaltyProgram.data';

import styles from './loyaltyProgram.module.scss';

const EditLoyaltyProgram = ({
  dispatch,
  history,
  match: { params },
  loyaltyProgram: { selectedLoyaltyProgram, loading },
}) => {
  const [status, setStatus] = useState(false);

  const editLoyaltyProgram = useCallback(
    body => {
      dispatch(
        actions.loyaltyProgram.editLoyaltyProgramAction(
          params.id,
          { ...body },
          history
        )
      );
    },
    [dispatch, history, params.id]
  );

  const deleteLoyaltyProgram = useCallback(() => {
    dispatch(actions.loyaltyProgram.deleteLoyaltyProgram(params.id, history));
  }, [dispatch, params.id, history]);

  const fetchLoyaltyProgram = useCallback(
    id => {
      dispatch(actions.loyaltyProgram.getLoyaltyProgramAction(id));
    },
    [dispatch]
  );

  const clearLoyaltyProgram = useCallback(() => {
    dispatch(actions.loyaltyProgram.clearLoyaltyProgramsAction());
  }, [dispatch]);

  useEffect(() => {
    fetchLoyaltyProgram(params.id);
    return () => clearLoyaltyProgram();
  }, [fetchLoyaltyProgram, clearLoyaltyProgram, params.id]);

  useEffect(() => {
    if (selectedLoyaltyProgram) {
      setStatus(selectedLoyaltyProgram.status === LoyaltyProgramStatus.ACTIVE);
    }
  }, [selectedLoyaltyProgram]);

  const toggleStatus = () => {
    const newStatus = status
      ? LoyaltyProgramStatus.INACTIVE
      : LoyaltyProgramStatus.ACTIVE;
    setStatus(status => !status);

    editLoyaltyProgram({ status: newStatus });
  };

  const onDeleteProgram = () => {
    deleteLoyaltyProgram();
  };

  const onSubmit = useCallback(
    data => {
      const goals = data.goals.map(goal => mapGoalToApiPayload(goal));
      editLoyaltyProgram({ ...data, goals });
    },
    [editLoyaltyProgram]
  );

  const defaultValues = selectedLoyaltyProgram || null;

  return (
    <section>
      <Header size="sm">
        <Title>{config.PAGES.editLoyaltyProgram}</Title>
        <div className={styles.actions}>
          {selectedLoyaltyProgram && (
            <div className={styles.activityToggleWrapper}>
              <Toggle
                onChange={toggleStatus}
                checked={status}
                showMeta={false}
                disabled={loading}
              />
              <span className={styles.toggleLabel}>Programa aktyvi</span>
            </div>
          )}
          <Button color="dim" onClick={onDeleteProgram}>
            Ištrinti
          </Button>
        </div>
      </Header>

      <Paper size="sm">
        <Form
          key={selectedLoyaltyProgram?.id}
          defaultValues={defaultValues}
          onSubmit={onSubmit}
          isEdit
        />
      </Paper>
    </section>
  );
};

const mapStateToProps = state => ({
  loyaltyProgram: state.loyaltyProgram,
});

EditLoyaltyProgram.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.object.isRequired,
  }).isRequired,
  loyaltyProgram: PropTypes.shape({
    selectedLoyaltyProgram: PropTypes.oneOfType([
      PropTypes.oneOf([null]),
      PropTypes.object,
    ]),
    loading: PropTypes.bool,
  }),
};

export default connect(mapStateToProps)(EditLoyaltyProgram);
